import React from 'react';
import logo from '../assets/images/z1logo.png';

const Sidebar = ({ isOpen, onClose }) => {
  // Prevent body scroll when sidebar is open
  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleLinkClick = () => {
    onClose(); // Close sidebar when a link is clicked
  };

  return (
    <>
      {/* Overlay */}
      <div
        className={`overlay-left ${isOpen ? 'open' : ''}`}
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 998,
          display: isOpen ? 'block' : 'none'
        }}
      ></div>

      {/* Sidebar */}
      <div
        className="sidebar-left"
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          width: '350px',
          height: '100%',
          backgroundColor: 'white',
          boxShadow: '-5px 0 15px rgba(0, 0, 0, 0.1)',
          zIndex: 999,
          padding: '40px 30px',
          transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 0.3s ease-in-out',
          overflowY: 'auto'
        }}
      >
        <div className="sidebar-close">
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#333'
            }}
          >
            <i className="lni lni-close"></i>
          </button>
        </div>

        <div className="sidebar-content">
          <div className="sidebar-logo" style={{ marginBottom: '40px' }}>
            <a href="/" onClick={handleLinkClick}>
              <img
                src={logo}
                alt="Logo"
                style={{
                  height: '150px',
                  width: '150px'
                }}
              />
            </a>
          </div>

          <div className="sidebar-menu" style={{ marginBottom: '40px' }}>
            <h5 className="menu-title" style={{
              fontSize: '18px',
              fontWeight: '600',
              marginBottom: '20px',
              color: '#333'
            }}>
              Quick Links
            </h5>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {['About Us', 'Our Team', 'Latest News', 'Contact Us'].map((item) => (
                <li key={item} style={{ marginBottom: '15px' }}>
                  <a
                    href={`#${item.toLowerCase().replace(' ', '-')}`}
                    onClick={handleLinkClick}
                    style={{
                      color: '#333',
                      textDecoration: 'none',
                      fontSize: '16px',
                      display: 'block',
                      padding: '8px 0',
                      transition: 'color 0.3s'
                    }}
                    onMouseEnter={(e) => e.target.style.color = '#18d04f'}
                    onMouseLeave={(e) => e.target.style.color = '#333'}
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="sidebar-social">
            <h5 className="social-title" style={{
              fontSize: '18px',
              fontWeight: '600',
              marginBottom: '20px',
              color: '#333'
            }}>
              Follow Us On
            </h5>
            <ul style={{
              display: 'flex',
              gap: '15px',
              listStyle: 'none',
              padding: 0
            }}>
              {[
                { name: 'facebook', icon: 'lni-facebook-filled', url: 'https://facebook.com' },
                { name: 'twitter', icon: 'lni-twitter-original', url: 'https://twitter.com' },
                { name: 'linkedin', icon: 'lni-linkedin-original', url: 'https://linkedin.com' },
                { name: 'youtube', icon: 'lni-youtube', url: 'https://youtube.com' }
              ].map((social) => (
                <li key={social.name}>
                  <a
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: '#666',
                      fontSize: '24px',
                      transition: 'color 0.3s'
                    }}
                    onMouseEnter={(e) => e.target.style.color = '#18d04f'}
                    onMouseLeave={(e) => e.target.style.color = '#666'}
                  >
                    <i className={`lni ${social.icon}`}></i>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;